import { css } from '@adornis/chemistry/directives/css.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import type { DialogOptions } from '@adornis/dialog/x-plain-dialog.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('tr-dialog')
export class TrDialog<T> extends XDialog<T> {
  static override get element_name() {
    return 'tr-dialog';
  }

  @property({ attribute: false }) hasCloseButton?: boolean;

  @state() public readonly _translation = new TranslationController(this);

  override render() {
    if (this.hasCloseButton)
      return html`
        ${this.content()}
        <tr-icon
          huge
          ${css({ cursor: 'pointer', position: 'absolute', right: this.spacing.md, top: this.spacing.md })}
          @click=${() => this.cancel()}
        >
          close
        </tr-icon>
      `;
    return this.content();
  }

  protected content() {
    return this.dialogShowPopupContent || html`no content set`;
  }

  override getInnerWrapper(options: Required<DialogOptions>) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty('background', this.colors.white);
    wrapperElem.style.setProperty('border-radius', this.sizes.borderRadius);
    wrapperElem.style.setProperty('width', `min(550px, 95%)`);
    wrapperElem.style.setProperty('padding', this.spacing.lg);
    wrapperElem.style.setProperty('position', 'relative');

    return wrapperElem;
  }
}
